/* eslint-disable camelcase */
import { determineClient } from '@utils/environmentUtils';
import store from '@components/common/store';
import type { MergedOfferItemData } from '@interfaces//offer';
import AnalyticsEvent from './AnalyticsEvent';
import type GaItemList from './GaItemList';
import type { ClientType } from '@/interfaces/common';
import { customAnalyticsDimensions } from './analytic-utils';

export default class ViewHotelAnalytics extends AnalyticsEvent {
	static determineValue(price: number, client: ClientType): number {
		let value: number;
		switch (client) {
		case 'com':
			value = price * 0.00004 + 0.04;
			break;
		case 'ch':
			value = price * 0.00008 + 0.11;
			break;
		case 'kuat':
			value = price * 0.00004 + 0.06;
			break;
		case 'lmat':
			value = price * 0.00007 + 0.07;
			break;
		case 'tbde': // TODO: tbde Mulitiplicator is not a defined yet
			value = price * 0.00007 + 0.07;
			break;
		default:
			value = price * 0.00006 + 0.07;
		}
		return +value.toFixed(3);
	}

	fireViewItem(): void {
		super.fireGoogleAnalyticsEventOrAddListener('view_item');
	}

	static createInstance(parsedData: any, offer: MergedOfferItemData): ViewHotelAnalytics {
		const hotelPackage = store.state.searchMask.onlyHotel ? 'Accommodation' : 'Package';
		const { value, price } = ViewHotelAnalytics.handleOutlier(offer);
		const { return_date, traveller_type, departure_date } = customAnalyticsDimensions();

		const itemList: GaItemList = {
			// send price and currency always in euros
			currency: offer.OriginalCurrencyCode,
			value,
			traveller_type,
			departure_date,
			return_date,
			items: [{
				item_id: parsedData.Hotel.IffCode.toString(),
				item_name: offer.Name,
				item_brand: offer.TourOperator.Code,
				item_category: parsedData.Location.Country.Name,
				item_category2: parsedData.Location.Region.Name,
				item_category3: parsedData.Location.City.Name,
				item_variant: hotelPackage,
				quantity: 1,
				price,
			}]
		};

		return new ViewHotelAnalytics(itemList);
	}

	private static handleOutlier(offer: MergedOfferItemData) {
		const price = offer.OriginalPrice <= 50000 ? offer.OriginalPrice : 0;
		const value = offer.OriginalPrice <= 50000 ? this.determineValue(price, determineClient(window.location.href)) : 0;
		return { value, price };
	}
}
